
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React, { useRef } from "react";
import { getResourceCollection } from "next-drupal";
import Layout from "components/Layout";
import { DrupalJsonApiParams } from "drupal-jsonapi-params";
import { getGlobals } from "lib/getGlobals";
import Meta from "components/Meta";
import useTranslation from "next-translate/useTranslation";
import Header from "components/Header";
import NodePageList from "components/Page/NodePageList";

export default function ExhibitionIndexPage({ nodes, globals }) {
  const { t } = useTranslation("common");
  const ref = useRef(null);

  const crumbs = [
    {
      path: "home.path",
      title: "home.title",
      translate: true,
    },
    {
      title: "exhibition.title",
      translate: true,
    },
  ];

  return (
    <Layout
      globals={globals}
      header={
        <Header
          crumbs={crumbs}
          title={t("exhibition.title")}
          imageFallback="/images/bg-05.jpg"
        />
      }
    >
      <Meta
        title={t("exhibition.title")}
        description={t("exhibition.description")}
      />
      <section className="relative pt-16 pb-24">
        <div ref={ref} className="container mx-auto px-4 transition-all">
          <NodePageList nodes={nodes} />
        </div>
      </section>
    </Layout>
  );
}

 async function _getStaticProps(context) {
  const localeContext = {
    locale: context.locale,
    defaultLocale: context.defaultLocale,
  };

  const params = new DrupalJsonApiParams();

  params.addInclude(["field_images"]).addFilter("status", 1);

  const nodes = await getResourceCollection("node--exhibition", {
    params: params.getQueryObject(),
    ...localeContext,
  });

  return {
    props: {
      globals: await getGlobals(context),
      nodes,
    },
    revalidate: 30,
  };
}


    export async function getStaticProps(ctx) {
        let res = _getStaticProps(ctx)
        if(typeof res.then === 'function') res = await res
        return {
          
          ...res,
          props: {
            ...(res.props || {}),
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/node--exhibition/index',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  